var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.5,
    height: 40.5,
    viewBox: "0 0 40.5 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "re",
    transform: "translate(-168.56 -168.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9246",
    "data-name": "Path 9246",
    d: "M188.81,208.81a20,20,0,1,1,20-20A20.022,20.022,0,0,1,188.81,208.81Zm0-38.571a18.571,18.571,0,1,0,18.571,18.571A18.593,18.593,0,0,0,188.81,170.239Z",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9251",
    "data-name": "Path 9251",
    d: "M265.532,268.46a2.452,2.452,0,0,1-1.736-.718l-6-5.937a8.261,8.261,0,0,0-3.562-2.074,4.308,4.308,0,0,1-2.355-1.671l-4.821-6.893a2.608,2.608,0,0,1,.434-3.55,2.478,2.478,0,0,1,3.287.167l16.488,16.488a2.453,2.453,0,0,1-1.734,4.189Zm1.3-1.152h0Zm-17.79-19.016a1.321,1.321,0,0,0-1.02,2.122l4.858,6.942a3.074,3.074,0,0,0,1.682,1.194,9.482,9.482,0,0,1,4.093,2.383l6,5.94a1.256,1.256,0,0,0,1.739,0,1.23,1.23,0,0,0,0-1.736l-16.486-16.488a1.224,1.224,0,0,0-.869-.36Z",
    transform: "translate(-68.281 -69.158)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9252",
    "data-name": "Path 9252",
    d: "M413.611,297.517a.613.613,0,0,1-.434-1.047,3.274,3.274,0,0,1,2.6-.895,3.685,3.685,0,0,0,2.825-1.068l3.411-3.4a.613.613,0,1,1,.866.868l-3.407,3.4A4.861,4.861,0,0,1,415.7,296.8a2.058,2.058,0,0,0-1.651.537.625.625,0,0,1-.435.178Z",
    transform: "translate(-220.922 -109.377)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9253",
    "data-name": "Path 9253",
    d: "M249.436,407.949a2.452,2.452,0,0,1-1.734-4.186l4.412-4.412a.614.614,0,1,1,.868.868l-4.412,4.412a1.228,1.228,0,0,0,0,1.734,1.229,1.229,0,0,0,1.734,0l5.471-5.472a.614.614,0,1,1,.868.868l-5.471,5.472a2.454,2.454,0,0,1-1.736.716Z",
    transform: "translate(-68.675 -208.645)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9254",
    "data-name": "Path 9254",
    d: "M381.654,226.978a.612.612,0,0,1-.476-1,2.575,2.575,0,0,0,.62-1.732,4.926,4.926,0,0,1,1.42-3.766l3.481-3.473a.613.613,0,1,1,.866.868l-3.477,3.469a3.711,3.711,0,0,0-1.065,2.836,3.8,3.8,0,0,1-.891,2.569.619.619,0,0,1-.478.226Z",
    transform: "translate(-191.616 -41.424)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9255",
    "data-name": "Path 9255",
    d: "M418.121,246.923a.613.613,0,0,1-.434-1.047l4.406-4.406a.614.614,0,1,1,.868.868l-4.406,4.406A.611.611,0,0,1,418.121,246.923Z",
    transform: "translate(-225.057 -63.856)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9256",
    "data-name": "Path 9256",
    d: "M443.4,272.2a.613.613,0,0,1-.434-1.047l4.406-4.406a.614.614,0,1,1,.868.868l-4.406,4.406A.612.612,0,0,1,443.4,272.2Z",
    transform: "translate(-248.241 -87.04)",
    fill: "#272d3b",
    stroke: "#272d3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.f563b8b941ca81ad9319f72521409ed4.svg";
export { ForwardRef as ReactComponent };